import React from 'react';
import { IconButton, Tooltip } from 'seagull';
import { AnchorIcon, AnchorIconGrayscale } from 'seagull/icons';
import { Intent } from "../../infra/access-control";
export default function EnterAccountantAccessButton(props) {
  const {
    variant = 'default',
    testid,
    onClick
  } = props;
  return variant === 'default' ? /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: "Go to client portal"
  }, /*#__PURE__*/React.createElement(IconButton, {
    intent: Intent.EnterAccountantAccess,
    "data-testid": testid,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(AnchorIcon, {
    width: 24
  }))) : /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: "Pending Accountant Access approval"
  }, /*#__PURE__*/React.createElement(IconButton, {
    cursorDefault: true,
    skin: "transparent",
    "data-testid": testid,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(AnchorIconGrayscale, null)));
}